import { render, staticRenderFns } from "./review-edit-dialog.vue?vue&type=template&id=3a2b5f42&scoped=true&"
import script from "./review-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./review-edit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./review-edit-dialog.vue?vue&type=style&index=0&id=3a2b5f42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b5f42",
  null
  
)

export default component.exports